import TaxFormTemplatesPage from './components/TaxFormTemplatesPage';

export default TaxFormTemplatesPage;
